import i18n from 'modules/core/lib/i18n'

export const getCopies = (employeeFullName: string) => {
  return {
    create: i18n.t('contract_versions.modals.quick_flows.create_without_contracts.title'),
    promote: i18n.t('contract_versions.modals.quick_flows.promote.label'),
    update: i18n.t('contract_versions.modals.quick_flows.update.label'),
    fix: i18n.t('contract_versions.modals.quick_flows.fix.label', {
      employeeFullName: employeeFullName,
    }),
  }
}
